export default {"src":"/_next/static/media/relevant.bfcdc8f9.svg","height":50,"width":50,"blurWidth":0,"blurHeight":0};